export default __webpack_public_path__ + "b2ce9a819d2d0bdf27b555a56921010e.svg";